<template>
<header class="main-header">
    <b-navbar class="navbar navbar-expand-lg navbar-dark" toggleable="lg">
        <router-link tag="a" :to="{ name: 'welcome' }" class="navbar-brand logo">
            Data Providers
        </router-link>
        <b-navbar-toggle target="header_nav"></b-navbar-toggle>
        <b-collapse id="header_nav" is-nav>
            <b-navbar-nav>
                <li class="nav-item">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text">Organization</label>
                        </div>
                        <b-form-select class="custom-select" ref="selectOrganization" :value="organization" @change="setOrganizationSelected">
                            <option :value="-1" disabled>Choose Organization</option>
                            <option v-for="organization in organizations"
                                    :value="organization.id"
                                    v-bind:key="organization.id">
                                    {{ organization.name }}
                            </option>
                        </b-form-select>
                    </div>
                </li>
                <b-nav-item @click="goRoute('organization')" class="d-md-none d-lg-none">
                    <font-awesome-icon icon="building" style="width: 25px" />
                    Organizations
                </b-nav-item>
                <b-nav-item @click="goRoute('connection')" class="d-md-none d-lg-none">
                    <font-awesome-icon icon="database" style="width: 25px" />
                    Connections
                </b-nav-item>
                <b-nav-item @click="goRoute('query')" class="d-md-none d-lg-none">
                    <font-awesome-icon icon="terminal" style="width: 25px" />
                    Queries
                </b-nav-item>
                <b-nav-item @click="goRoute('visualization')" class="d-md-none d-lg-none">
                    <font-awesome-icon icon="chart-pie" style="width: 25px" />
                    Visualizations
                </b-nav-item>
                <b-nav-item @click="goRoute('report')" class="d-md-none d-lg-none">
                    <font-awesome-icon icon="file-alt" style="width: 25px" />
                    Reports
                </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-form>
                    <b-nav-item-dropdown right>
                        <template slot="button-content">
                            <font-awesome-icon icon="user-circle" />
                            {{ this.account.name }}
                        </template>
                        <b-dropdown-item @click="goRoute('account')">
                            <font-awesome-icon icon="user-circle" /> Account
                        </b-dropdown-item>
                        <b-dropdown-item @click.prevent="logout()">
                            <font-awesome-icon icon="sign-out-alt" /> Logout
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-nav-form>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</header>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        data() {
            return {
            }
        },
        created() {
            this.$store.dispatch('fetchOrganizations').then(() => {
                this.checkSelectedOrganization();
            });
        },
        computed: {
            ...mapState({
                organization: 'organizationSelected',
                organizations: state => state.organizations,
                account: state => state.account,
            }),
            ...mapGetters({
                selected: 'getOrganizations'
            }),
        },
        methods: {
            setOrganizationSelected (e) {
                this.$swal({
                    title: 'Be careful',
                    text: "All displayed data will change and unsaved changes will be lost ",
                    type: 'warning',
                    width: '350px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('fetchAccount')
                            .then(() => {
                                let payload = {
                                    id: this.$store.getters.getAccount.id,
                                    default_organization_id: e,
                                };
                                this.$store.dispatch('setOrganizationSelected', payload).then(() => {
									this.$store.commit('SET_ORGANIZATION_SELECTED', payload.default_organization_id);
								});
                            });
                    }
                    else {
                        this.$refs.selectOrganization.localValue = this.organization;
                    }
                });
            },
            checkSelectedOrganization() {
                if (this.$store.getters.getOrganizationSelected == -1) {
                    if ((this.$store.getters.getOrganizations).length === 0) {
                        this.$swal({
                            title: '👋 Welcome!, First action',
                            text: "👩‍🏫 Organizations allow you to separate and organize objects in workspaces. Each organization has their own subscription plan, choose the plan that fits your needs.",
                            type: 'info',
                            width: '350px',
                            showCancelButton: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Create my first organization'
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({name: 'organization.create'});
                            }
                        });
                    }
                    else {
                        this.$store.dispatch('fetchAccount')
                            .then(() => {
                                let organizationsId = this.$store.getters.getOrganizations.map(({ id }) => id);
                                if ((organizationsId).includes(parseInt(this.$store.getters.getAccount.default_organization_id))) {
                                    this.$store.commit('SET_ORGANIZATION_SELECTED', this.$store.getters.getAccount.default_organization_id);
                                }
                                else {
                                    let organizationSelected = this.$store.getters.getOrganizations[0].id;
                                    this.$store.commit('SET_ORGANIZATION_SELECTED', organizationSelected);
                                }
                            });
                    }
                }
                else {
                    let organizationsId = this.$store.getters.getOrganizations.map(({ id }) => id);
                    if (!(organizationsId.includes(parseInt(this.$store.getters.getOrganizationSelected)))) {
                        this.$store.commit('SET_ORGANIZATION_SELECTED', -1);
                        this.checkSelectedOrganization();
                    }
                }
            },
            logout() {
                this.$auth.logout();
                this.$store.commit('SET_ORGANIZATION_SELECTED', -1);
            },
            goRoute(route) {
                this.$router.push({ name: route ,query: {page: 1}});
            }
        },
        watch:{
            $route (to, from){
                if (!this.$router.currentRoute.name.includes('organization') && to.name !== 'account.email.activate.logged') {
                    this.checkSelectedOrganization();
                }
            }
        }
    }
</script>

<style>
    .main-header .logo {
        height: 55px;
        padding-top: 3px;
        padding-right: 0;
    }
    .main-sidebar {
        padding-top: 55px;
    }

    .dropdown-menu.right {
        left: 20px;
        top: 33px;
    }

    .navbar-toggler:not(:disabled):not(.disabled) {
        cursor: pointer;
        margin-bottom: 10px;
    }
</style>
